import client from './client'

// Get paginated list of dimension change requests
export const getDimensionRequests = async ({ page = 1, perPage = 25, status, productId } = {}) => {
  const params = new URLSearchParams()
  params.append('page', page)
  params.append('per_page', perPage)
  if (status) params.append('status', status)
  if (productId) params.append('product_id', productId)

  const response = await client.get(`/dimension-requests?${params.toString()}`)
  return response.data
}

// Get pending count
export const getPendingCount = async () => {
  const response = await client.get('/dimension-requests/pending/count')
  return response.data
}

// Get dimension change request details
export const getDimensionRequest = async (id) => {
  const response = await client.get(`/dimension-requests/${id}`)
  return response.data
}

// Approve dimension change request
export const approveDimensionRequest = async (id, comment = null) => {
  const response = await client.post(`/dimension-requests/${id}/approve`, { comment })
  return response.data
}

// Reject dimension change request
export const rejectDimensionRequest = async (id, comment = null) => {
  const response = await client.post(`/dimension-requests/${id}/reject`, { comment })
  return response.data
}

// Status constants
export const DIMENSION_REQUEST_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected'
}

export const DIMENSION_REQUEST_STATUS_NAMES = {
  [DIMENSION_REQUEST_STATUS.PENDING]: 'Ожидает',
  [DIMENSION_REQUEST_STATUS.APPROVED]: 'Подтверждён',
  [DIMENSION_REQUEST_STATUS.REJECTED]: 'Отклонён'
}

export const DIMENSION_REQUEST_STATUS_COLORS = {
  [DIMENSION_REQUEST_STATUS.PENDING]: 'bg-yellow-100 text-yellow-800',
  [DIMENSION_REQUEST_STATUS.APPROVED]: 'bg-green-100 text-green-800',
  [DIMENSION_REQUEST_STATUS.REJECTED]: 'bg-red-100 text-red-800'
}
